import { makeActionCreator } from '../../config/store/utils'
import { getPurchaseOrdersHistory } from '../../services/purchaseOrder'

export const CLOSE_QUOTE_RECORDS_DIALOG = 'CLOSE_QUOTE_RECORDS_DIALOG'
export const onCloseQuoteRecordsDialog = makeActionCreator(CLOSE_QUOTE_RECORDS_DIALOG)

export const GET_PURCHASE_RECORDS = 'GET_PURCHASE_RECORDS'
export const GET_PURCHASE_RECORDS_ERROR = 'GET_PURCHASE_RECORDS_ERROR'
export const GET_PURCHASE_RECORDS_SUCCESS = 'GET_PURCHASE_RECORDS_SUCCESS'
export const onGetPurchaseRecords = makeActionCreator(GET_PURCHASE_RECORDS)
export const onGetPurchaseRecordsError = makeActionCreator(GET_PURCHASE_RECORDS_ERROR, 'payload')
export const onGetPurchaseRecordsSuccess = makeActionCreator(GET_PURCHASE_RECORDS_SUCCESS, 'payload')
export const onGetPurchaseRecordsThunk = payload => async dispatch => {
  dispatch(onGetPurchaseRecords())

  try {
    const { data } = await getPurchaseOrdersHistory({ quoteId: payload.quoteId })
    const records =
      data.payload?.map(item => ({
        createdAt: item.fecha,
        department: item.unidad,
        id: item.id,
        link: item.enlace,
        log: item.comentario,
        organization: item.organismo,
        user: item.usuario
      })) || []

    return dispatch(onGetPurchaseRecordsSuccess({ records }))
  } catch (error) {
    return dispatch(onGetPurchaseRecordsError({ error }))
  }
}

export const OPEN_QUOTE_RECORDS_DIALOG = 'OPEN_QUOTE_RECORDS_DIALOG'
export const onOpenQuoteRecordsDialog = makeActionCreator(OPEN_QUOTE_RECORDS_DIALOG)
